module.exports = __webpack_public_path__ + "img/file-------------1x-png@1x.4bb8de3c.png";